import { BrowserRouter, Route, Routes } from 'react-router-dom'
import ClientConfigTool from '../clientconfigtool/ClientConfigTool'
import ClientSettingsPage from '../clientconfigtool/ClientSettingsPage'
import ClientsService from '../service/clients'
import ConfigureWotcPage from '../clientconfigtool/ConfigureWotcPage'
import HideEEDFields from '../hideeedfields/HideEEDFields'
import Layout from './Layout'
import MergeTool from '../mergetool/MergeTool'
import PowerExtensionService from '../service/powerextension'
import PowerExtensions from '../powerextensions/PowerExtensions'
import ProtectedRoute from './ProtectedRoute'
import React from 'react'
import SyncApplStatus from '../syncapplstatus/SyncApplStatus'
import syncApplStatusService from '../service/syncApplStatus'

function Landing() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />} path="/">
          <Route
            element={
              <ProtectedRoute>
                <MergeTool />
              </ProtectedRoute>
            }
            path="merge-tool"
          />
          <Route
            element={
              <ProtectedRoute>
                <HideEEDFields clientsService={ClientsService} />
              </ProtectedRoute>
            }
            path="hide-eed-fields"
          />
          <Route
            element={
              <ProtectedRoute>
                <SyncApplStatus service={syncApplStatusService} />
              </ProtectedRoute>
            }
            path="sync-appl-status"
          />
          <Route
            element={
              <ProtectedRoute>
                <PowerExtensions
                  clientsService={ClientsService}
                  powerExtensionService={PowerExtensionService}
                />
              </ProtectedRoute>
            }
            path="power-extensions"
          />
          <Route
            element={
              <ProtectedRoute>
                <ClientConfigTool />
              </ProtectedRoute>
            }
            path="client-config-tool"
          />
          <Route
            element={
              <ProtectedRoute>
                <ClientSettingsPage />
              </ProtectedRoute>
            }
            path="client-config-tool/:clientId"
          />
        </Route>
        <Route
          element={
            <ProtectedRoute>
              <ConfigureWotcPage />
            </ProtectedRoute>
          }
          path="client-config-tool/wotc/:clientId"
        />
      </Routes>
    </BrowserRouter>
  )
}

export default Landing
